import gql from 'graphql-tag'

const cliente = gql`
  query cliente (
    $where: ClienteFilterInput
    $azioniOrderBy: [AzioniOrderBy!]
    $whereAzioni: AzioniFilterInput
  ) {
    cliente (where: $where) {
      id
      agenteId
      nome
      comune
      email
      email2
      telefono
      telefono2
      dataNascita
      lingua
      tipoPnl
      famiglia
      percheCompra
      quandoInteressato
      quantoInteressato
      voto
      dataCreazione
      daRicontattare
      dataUltimoContatto
      dataUltimaRichiesta
      zone {
        nome
      }
      interessi {
        nome
      }
      azioni (where: $whereAzioni, orderBy: $azioniOrderBy) {
        id
        tipoAzioneId
        tipoAzione {
          id
          tipo
        }
        clienteId
        utenteId
        utente {
          id
          nome
        }
        offertaId
        offerta {
          id
          nome
          tipoOffertaId
          tipoOfferta {
            id
            tipo
          }
        }
        campagnaId
        campagna {
          id
          nome
        }
        dataOra
        descrizione
        appuntamentoAgenteId
        appuntamentoAgente {
          id
          nome
        }
        appuntamentoDaDataOra
        appuntamentoADataOra
        appuntamentoLuogo
        appuntamentoOrigine
        appuntamentoStato
        appuntamentoFissatoData
        appuntamentoFissatoOperatore
        appuntamentoConfermatoSegretariaData
        appuntamentoConfermatoSegretariaOperatore
        promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
        votoAgente
        nonRisposto
      }
    }
  }
`

export default cliente


// WEBPACK FOOTER //
// ./src/graphql/queries/cliente.js